import { TabsProps as MuiTabsProps } from '@mui/material/Tabs';
import { TabsStyled } from './styled';

type TabsProps = MuiTabsProps;

export const Tabs = ({ children, ...otherProps }: TabsProps) => {
  return <TabsStyled {...otherProps}>{children}</TabsStyled>;
};
